<template>
    <div class="bankContainer"><img :src="`${authConfig.uploadPath}${params.data.bank.imageUrl}`"> </div>
</template>

<script>
import authConfig from '@/../auth_config.json'

export default {
  name: 'CellRendererVerified',
  data(){
    return{
      authConfig:authConfig
    }
  },
  computed: {
    textColor () {
      return this.params.value ? 'text-primary' : 'text-grey'
    }
  }
}
</script>
<style scoped>
  img{
    max-width: 100%
  }
  .bankContainer{
    display: flex;
    height: 100%;
    align-items: center;
  }
</style>